/**
 * /t/$slug/recovery/request — public submit-recovery flow.
 *
 * Sibling of /t/$slug/recovery (the completion / code-redemption
 * page). This route is where a user lands when they don't yet
 * have a recovery code — they ask an admin or 2 peers to
 * approve, then receive a single-use link via email when
 * approval lands and the code is theirs.
 */

import { recoveryRequestSearchSchema } from "@pureid/auth-core";
import { createFileRoute } from "@tanstack/react-router";
import { RecoveryRequestPage } from "@/features/recovery-request/pages/recovery-request-page";

export const Route = createFileRoute("/t/$slug/recovery/request")({
  validateSearch: recoveryRequestSearchSchema,
  component: RecoveryRequestPage,
});
